<!-- <div *ngIf="this.isLoading$ | async" class="d-flex align-items-center">
  <strong>Loading...</strong>
  <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
</div> -->

<ng-container>
  @if (this.isLoading$ | async) {
    <div class="wrapper d-flex">
      <div class="m-auto">
        <svg class="spinner" width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
       </svg>
      </div>
    </div>
  }
</ng-container>
